/**
 * @fileoverview POST handler for the "/apps/upload_message" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUploadMessageCacheKeys } from "./constants";
import type { AppsUploadMessageProps, AppsUploadMessageResult } from "./types";

export const postAppsUploadMessage = reactQueryMutationAdapter(
  appsUploadMessageCacheKeys,
  ({ zip_url }: AppsUploadMessageProps): Promise<AppsUploadMessageResult> => {
    const body = new FormData();
    body.append("zip_url", zip_url);

    return fetch("/apps/upload_message", "POST", {}, { body }, { setContentType: false });
  }
);
